var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBeliefs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 12.8398C15.0001 10.6884 16.6817 8.94434 18.7561 8.94434C20.8306 8.94434 22.5122 10.6884 22.5122 12.8398C22.5122 13.9296 22.0808 14.9148 21.3854 15.6218L15.0001 22.2993",
    stroke: "#0088C1",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 12.8398C14.9999 10.6884 13.3183 8.94434 11.2439 8.94434C9.16944 8.94434 7.48779 10.6884 7.48779 12.8398C7.48779 13.9296 7.91923 14.9148 8.61462 15.6218L14.9999 22.2993",
    stroke: "#0088C1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeliefs);
export default __webpack_public_path__ + "static/media/Beliefs.e053b516ac5b8e7eb9514ad97dd05005.svg";
export { ForwardRef as ReactComponent };